export default [
  {
    name: 'Administrador',
    type: 'admin',
    organizations: null
  },
  {
    name: 'Generador de Folios',
    type: 'medical_center',
    organizations: ['medical_center']
  },
  {
    name: 'Químico farmacéutico',
    type: 'dispenser_admin',
    organizations: ['midas'],
    remoteOnly: true
  },
  {
    name: 'Auxiliar de Farmacia',
    type: 'dispenser',
    organizations: ['midas']
  }
];
